var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"pa-3 mr-4"},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"list-item"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }